import { Footer } from "../../Footer/Footer"
import { HerosectionsAll } from "../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../IndexPage/Header/Header"


export const Mission = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="Missions" subactive="About" />
                    <HerosectionsAll ScreenName="Mission" ScreenSearch="Mission" />

                    <div className="row p-2 px-lg-5 ">

                        <div className="col-12 col-lg-6 p-lg-5 d-flex p-4 justify-content-center align-items-center">
                            <div className="row px-lg-5 py-4 faint rounded vision_Mission">
                                <div className="col-12">
                                    {/* <h2 className="fw-bold display-5 green">Mission</h2>
                                    <div className="col-8 col-lg-3 mb-3  zoom-in-out-box2 text-center">
                                        <hr />
                                    </div> */}
                                </div>
                                <div className="col-12">
                                    <p className="" style={{ textAlign: 'justify', fontSize: '20px' }}>We believe in continuous Professional Development (CPD) and strive for excellence in facilitating learning and simplify the understanding of how risk transfer by contracts and insurance are an indispensable link in managing risk effectively. </p>
                                </div>
                            </div>
                        </div>

                        

                        <div className="col-12 pb-4 pb-lg-0 col-lg-6 px-lg-5 d-flex  justify-content-center align-items-center">
                            <img src="Static/Assets/Img/mission-01.JPG" className="Marine_insurance_mission" alt="" />
                        </div>

                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
